export default __webpack_public_path__ + "static/media/logoLine.10dd5d7a.webp";